module.exports = __webpack_public_path__ + "static/img/88-1.80b0f48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/88-1.jpg
// module id = zFK0
// module chunks = 0